import React from "react";

// Profile awards under the raider (Jack, 2026-10-23): two per game, one for
// 5 wins and one for 3 wins in a row, people-only games (backend
// profile_awards.py). Same gold shield as the in-game award pop-ups
// (jangle.html AWARD_ART), ribbon in the game's colour. Grey with a progress
// bar until earned.

const raider = (x, y, c) =>
  `<g transform="translate(${x} ${y})"><circle cx="0" cy="0" r="6" fill="#ffd8b0"/><rect x="-6" y="6" width="12" height="15" rx="3" fill="${c}"/><path d="M-4 21l-4 6M4 21l4 5" stroke="#333" stroke-width="2.6" stroke-linecap="round"/><path d="M-6 10l-7 6M6 10l7 -5" stroke="${c}" stroke-width="3" stroke-linecap="round"/><circle cx="-2" cy="-1" r="1" fill="#333"/><circle cx="3" cy="-1" r="1" fill="#333"/></g>`;

const chequers = (() => {
  let s = "";
  for (let r = 0; r < 2; r++)
    for (let k = 0; k < 10; k++)
      s += `<rect x="${15 + k * 9}" y="${14 + r * 9}" width="9" height="9" fill="${(r + k) % 2 ? "#fff" : "#222"}"/>`;
  return s;
})();

// Scenes are drawn in a 120x100 box, like AWARD_ART.
const SCENE = {
  classic:
    '<rect x="0" y="82" width="120" height="18" fill="#3f8f4a"/>' +
    '<g fill="#9aa4b2" stroke="#5b6472" stroke-width="2"><rect x="40" y="38" width="46" height="46"/><rect x="36" y="26" width="14" height="58"/><rect x="76" y="26" width="14" height="58"/>' +
    '<path d="M36 26h4v-6h6v6h4M76 26h4v-6h6v6h4"/><path d="M40 38h6v-6h6v6h6v-6h6v6h6v-6h6v6h6"/></g>' +
    '<path d="M56 84v-16a7 7 0 0 1 14 0v16z" fill="#4a3426"/>' +
    '<line x1="63" y1="30" x2="63" y2="4" stroke="#5b6472" stroke-width="2.5"/><path d="M63 4l16 5-16 5z" fill="#f393a1"/>' +
    '<g font-family="Arial,sans-serif" font-weight="800" font-size="12" text-anchor="middle">' +
    '<g transform="rotate(-14 16 70)"><rect x="6" y="58" width="20" height="23" rx="3" fill="#f393a1" stroke="#c96b79" stroke-width="2"/><text x="16" y="75" fill="#3a1d22">J</text></g>' +
    '<g transform="rotate(12 104 70)"><rect x="94" y="58" width="20" height="23" rx="3" fill="#f393a1" stroke="#c96b79" stroke-width="2"/><text x="104" y="75" fill="#3a1d22">W</text></g></g>',
  mino:
    '<ellipse cx="60" cy="56" rx="40" ry="36" fill="#7c3aed"/><ellipse cx="60" cy="56" rx="30" ry="27" fill="#a78bfa"/><ellipse cx="60" cy="56" rx="19" ry="17" fill="#ddd6fe"/>' +
    '<path d="M30 34 q-14 -6 -14 -26 q8 12 22 16z M90 34 q14 -6 14 -26 q-8 12 -22 16z" fill="#f5e6c8" stroke="#2b1f2a" stroke-width="2.5" stroke-linejoin="round"/>' +
    '<path d="M34 30 q26 -12 52 0 q4 16 -2 30 q-4 22 -24 26 q-20 -4 -24 -26 q-6 -14 -2 -30z" fill="#b7793a" stroke="#2b1f2a" stroke-width="3" stroke-linejoin="round"/>' +
    '<ellipse cx="60" cy="74" rx="15" ry="10" fill="#e3b583" stroke="#2b1f2a" stroke-width="2.5"/><circle cx="54" cy="74" r="2.4" fill="#2b1f2a"/><circle cx="66" cy="74" r="2.4" fill="#2b1f2a"/>' +
    '<circle cx="60" cy="86" r="5" fill="none" stroke="#facc15" stroke-width="2.5"/>' +
    '<path d="M44 50 l8 3 M76 50 l-8 3" stroke="#2b1f2a" stroke-width="3" stroke-linecap="round"/><circle cx="49" cy="56" r="3" fill="#2b1f2a"/><circle cx="71" cy="56" r="3" fill="#2b1f2a"/>',
  race:
    '<rect x="0" y="82" width="120" height="18" fill="#3f8f4a"/>' +
    '<line x1="14" y1="84" x2="14" y2="14" stroke="#5b6472" stroke-width="3"/><line x1="106" y1="84" x2="106" y2="14" stroke="#5b6472" stroke-width="3"/>' +
    chequers +
    '<path d="M15 64 h90" stroke="#fff" stroke-width="2" stroke-dasharray="4 3" opacity=".9"/>' +
    raider(48, 52, "#4FB0F0") + raider(76, 58, "#f393a1") +
    '<path d="M30 60h8M28 66h10M34 72h6" stroke="#fff" stroke-width="2" stroke-linecap="round" opacity=".8"/>',
};

const GAMES = [
  { key: "classic", name: "Classic", ribbon: ["#f393a1", "#c96b79"] },
  { key: "mino", name: "Minotauro", ribbon: ["#a78bfa", "#6d28d9"] },
  { key: "race", name: "Raider Races", ribbon: ["#34d399", "#047857"] },
];

const FLAME =
  '<path d="M0 -11 c1 5 7 8 7 14 a7 7 0 0 1 -14 0 c0 -4 2 -6 3 -8 c0 3 1 4 2 5 c1 -4 -1 -8 2 -11z" fill="#fff"/>' +
  '<path d="M0 1 c1 2 3 3 3 5 a3 3 0 0 1 -6 0 c0 -2 1 -3 3 -5z" fill="#f59e0b"/>';

function shieldSvg(game, kind, wins) {
  const id = `paw-${game.key}-${kind}`;
  const [r1, r2] = game.ribbon;
  const chip =
    kind === "wins"
      ? `<circle cx="136" cy="152" r="20" fill="#22c55e" stroke="#fff" stroke-width="4"/><text x="136" y="160" text-anchor="middle" font-family="Arial,sans-serif" font-weight="900" font-size="22" fill="#fff">${wins}</text>`
      : `<circle cx="136" cy="152" r="20" fill="#f97316" stroke="#fff" stroke-width="4"/><g transform="translate(136 152) scale(1.15)">${FLAME}</g>`;
  return (
    `<svg viewBox="0 0 160 186" aria-hidden="true" class="w-full h-full"><defs><linearGradient id="${id}" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#fde68a"/><stop offset=".5" stop-color="#f59e0b"/><stop offset="1" stop-color="#fbbf24"/></linearGradient></defs>` +
    `<path d="M80 6c22 12 46 16 72 14v72c0 44-30 72-72 90C38 164 8 136 8 92V20c26 2 50-2 72-14z" fill="url(#${id})" stroke="#b45309" stroke-width="2"/>` +
    '<path d="M80 20c19 10 39 14 60 13v59c0 37-25 60-60 76-35-16-60-39-60-76V33c21 1 41-3 60-13z" fill="#fffdf5" stroke="#fde68a" stroke-width="3"/>' +
    `<svg x="22" y="44" width="116" height="96" viewBox="0 0 120 100">${SCENE[game.key]}</svg>` +
    `<path d="M62 0h36v30l-18-9-18 9z" fill="${r1}" stroke="${r2}" stroke-width="1.5"/>` +
    chip +
    "</svg>"
  );
}

function Award({ game, kind, stats }) {
  const goal = kind === "wins" ? stats.wins_goal : stats.streak_goal;
  const have = kind === "wins" ? stats.wins : stats.best_streak;
  const done = have >= goal;
  const sub = done
    ? kind === "wins" ? `${goal} wins` : `${goal} wins in a row`
    : kind === "wins" ? `${have} / ${goal} wins` : `best ${have} in a row`;
  const what = kind === "wins" ? `${goal} wins` : `${goal} wins in a row`;
  return (
    <div
      className="flex flex-col items-center text-center w-24"
      title={`${game.name}: ${what} against other players`}
      data-testid={`award-${game.key}-${kind}`}
      data-earned={done ? "1" : "0"}
    >
      <div
        className={`w-[58px] h-[67px] ${done ? "drop-shadow-md" : "grayscale opacity-30"}`}
        dangerouslySetInnerHTML={{ __html: shieldSvg(game, kind, goal) }}
      />
      <div className={`text-[11px] font-bold leading-tight mt-1 ${done ? "" : "text-muted-foreground"}`}>{game.name}</div>
      <div className="text-[10px] text-muted-foreground">{sub}</div>
      {!done && (
        <div className="w-12 h-1 rounded bg-border mt-0.5 overflow-hidden">
          <div className="h-full bg-brand" style={{ width: `${Math.min(100, (have / goal) * 100)}%` }} />
        </div>
      )}
    </div>
  );
}

export default function ProfileAwards({ awards }) {
  if (!awards) return null;
  return (
    <div
      className="grid grid-cols-3 gap-y-3.5 justify-items-center pb-5 mb-5 border-b border-border"
      data-testid="profile-awards"
    >
      {["wins", "streak"].map((kind) =>
        GAMES.map((g) => (
          <Award key={`${g.key}-${kind}`} game={g} kind={kind} stats={awards[g.key] || { wins: 0, best_streak: 0, wins_goal: 5, streak_goal: 3 }} />
        )),
      )}
    </div>
  );
}
